import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  data() {
    return {
      datasets: [],
      labels: [],
    };
  },
  computed: {
    ...mapState('charts', {
      chartCrop: (state) => state.crop,
      chartVariety: (state) => state.variety,
      chartMonth: (state) => state.month,
      chartDistributor: (state) => state.distributor,
      chartState: (state) => state.state,
    }),
    ...mapState('models/projection', {
      projectionCurrentTableSearch: (state) => state.currentTableSearch,
    }),

    ...mapGetters('models/order', {
      getOrderStateByName: 'getStateByName',
    }),

    orderAcceptedState() {
      return this.getOrderStateByName('accepted').id;
    },

    hasActiveChartFilters() {
      return Boolean(this.chartCrop || this.chartVariety || this.chartMonth || this.chartDistributor);
    },
  },
  methods: {
    ...mapActions('charts', {
      setChartCrop: 'setCrop',
      setChartVariety: 'setVariety',
      setChartMonth: 'setMonth',
      setChartDistributor: 'setDistributor',
      setChartState: 'setState',
    }),

    ...mapActions('models/projection', {
      setProjectionState: 'setCurrentTableStateFilter',
    }),
    ...mapActions('models/order', {
      setOrderSearch: 'setCurrentTableSearch',
      setOrderState: 'setCurrentTableStateFilter',
    }),

    ...mapActions('navigation', {
      setNavigationCampaign: 'setCampaign',
    }),

    getExtraData(action, { order = false, projection = false, previousCampaign = false, route = null, state = null }) {
      const data = { action, campaign: previousCampaign ? this.previousCampaignId : this.currentCampaignId };

      if (order) {
        const fn = () => {
          this.setOrderSearch(this.projectionCurrentTableSearch);
          this.setOrderState(null);
        };

        return { state: state || this.orderAcceptedState, route: route || 'OrdersList', fn, ...data };
      }

      if (projection) {
        const fn = () => {
          this.setProjectionState(null);
        };
        return { state, route: route || 'ProjectionsList', fn, ...data };
      }

      return null;
    },

    resetChartFilters(clearDistributor = true) {
      if (clearDistributor) {
        this.setChartDistributor(null);
      }

      this.setChartCrop(null);
      this.setChartVariety(null);
      this.setChartMonth(null);
      this.setChartState(null);
      this.$emit('refresh');
    },

    handleChartClick(evt, elements) {
      if (!this.$refs.chart) {
        return;
      }
      const chart = this.$refs.chart.$data._chart;
      const chartIndex = chart.getElementAtEvent(evt);

      if (chartIndex.length !== 0) {
        const dataset = chartIndex[0]._datasetIndex;
        const value = chartIndex[0]._index;
        const label = chartIndex[0]._model.label;
        this.showData(dataset, value, label);
      }
    },

    showData(dataset, value, label) {
      if (this.datasets.length === 0 || this.labels.length === 0) {
        return;
      }

      this.$emit('chartSearch');

      const datasetData = this.datasets[dataset].extraData;
      const action = datasetData.action;

      if (this[action]) {
        this[action](this.labels[label]);
      }

      this.setNavigationCampaign(datasetData.campaign);

      if (datasetData.fn) {
        datasetData.fn();
      }

      if (datasetData.state) {
        this.setChartState(datasetData.state);
      }

      this.$router.push({ name: datasetData.route });
    },
  },
};
